﻿<template>
    <div>
        <toast></toast>
        <div class="col-md-5 pt-3 centre_sm_none"
             :class="{'d-sm-block':viewToggle||!clickToggle,'d-none':viewToggle||!clickToggle}">
            <div class="right_list_content">
                <div class="d-flex justify-content-between border-bottom pl-3" style="position:relative">
                    <div class="mytitle">My demand</div>
                    <span class="myBtn" @click='gobackAdd()' v-if='!IsPC()'>Add demand</span>
                    <span class="myBtn" @click='gobacks()' v-if='IsPC()&&detailShow'>Add demand</span>
                </div>
                <div class="row nano p-0 m-0 one_title_nano has-scrollbar">
                    <div class="nano-content" id="home_left_list">
                        <ul class="list-unstyled" style="padding:0 15px">
                            <li v-for='item in homeLists' :class="{'cur':item.id==curIndex}"
                                class="lItem" @click="gotodetai(item.id)">
                                <span class="Lblock">{{item.type_name}}</span>
                                <p class="Ldes two_ell">{{item.content}}</p>
                                <div class="itemBottom">
                                    <div class="Ldetail">
                                        <div class="imgdiv">
                                            <img :src="item.space.photo" alt="" />
                                        </div>
                                        <span class="Lname">{{item.space.name}}</span>
                                        <span class="Ljob" v-if="item.space.tags">{{item.space.tags}}</span>
                                    </div>
                                    <span class="time">{{item.addtime}}</span>
                                </div>
                                <div class="replayCont" v-if="item.is_reply==1">
                                    <span class="replayTime">Response time：{{item.replytime}}</span>
                                    <span class="replayicon">Replied</span>
                                </div>
                            </li>
                            <!--<p class="text-center p-2" v-if="homeLists&&homeLists.length !=0">没有更多数据了...</p>-->
                        </ul>
                        <div v-if="homeLists&&homeLists.length ==0" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="">
                            <p class="text-center p-2">loading</p>

                        </div>
                    </div>
                </div>

            </div>
        </div>
        <div class="col-md-7 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':viewToggle||clickToggle,'d-none':viewToggle||clickToggle}">
            <div class="right_list_content" v-if="!detailShow">
                <div class="d-flex justify-content-between border-bottom pl-3" style="position:relative">
                    <div class="mytitle">Consult Xinhua Silk Road Database</div>
                    <span class="myBtn" @click='gobackList()' v-if='!IsPC()'>Demand list</span>
                </div>
                <div class="row nano one_title_nano m-0">
                    <div class="row nano-content m-0 tab-content w-100 addneed">
                        <div class="w-100">
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-xs-6 col-3 col-form-label tc pr-0" style="margin-right: 0">Type<span style="color:red">*</span></label>
                                <div class="col-md-3" style="padding-left: 0">
                                    <select v-model="selectType" class="form-control">
                                        <option v-for='item in type' :value="item.id">{{item.name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-xs-6 col-3 col-form-label tc pr-0" style="margin-right: 0">Specific Needs<span style="color:red">*</span></label>
                                <div class="col-md-8" style="padding-left: 0">
									<textarea v-model="content" class="form-control w-100" placeholder="For example, analysts are required to assist in research and generating reports" style="overflow:hidden;"></textarea>
                                </div>
                            </div>
                            <!--<div class="form-group row ml-0 mr-0">
                                <label class="col-md-2 col-3 col-form-label tc">需求单位</label>
                                <div class="col-md-6">
                                    <input type="text" class="col-12 form-control">
                                </div>
                            </div>
                            <div class="row">
                            <div class="form-group col-md-6 ml-0 mr-0">
                                <label class="col-md-4 col-form-label tc">姓名<span style="color:red">*</span></label>
                                <div class="col-md-6" style="display: inline-block;">
                                    <input type="text" class="col-12 form-control">
                                </div>
                            </div>
                            <div class="form-group col-md-6 ml-0 mr-0">
                                <label class="col-md-3 col-form-label tc">电话<span style="color:red">*</span></label>
                                <div class="col-md-6" style="display: inline-block;">
                                    <input type="text" class="col-12 form-control" >
                                </div>
                            </div>
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-2 col-3 col-form-label tc">email</label>
                                <div class="col-md-6">
                                    <input type="text" class="col-12 form-control"/>
                                </div>
                            </div>

                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-2 col-3 col-form-label tc">地址</label>
                                <div class="col-md-6">
                                    <input type="text" class="col-12 form-control" />
                                </div>
                            </div>-->
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-xs-6 col-3 col-form-label tc pr-0" style="margin-right: 0">Verification code</label>
                                <div class="col-md-6" style="padding-left: 0">
                                    <input type="text" v-model="captcha" class="col-md-3 " />
                                    <img :src="codeUrl" id="code" @click='refresh()' class="col-md-6 " height="30"/>
                                </div>
                            </div>
                            <div class="form-group row ml-0 mr-0 ">
                                <label class="col-md-3 col-xs-6 col-3 col-form-label tc pr-0" style="margin-right: 0"></label>
                                <div class="col-md-6" style="padding-left: 0">
                                    <button type="submit" @click="addContent()" class="btn btn-primary" style="width: 100px;">Save</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="right_list_content" v-if="detailShow && detail">
                <div class="d-flex justify-content-between border-bottom pl-3" style="position:relative">
                    <div class="mytitle">
                        <div class="imgdiv add">
                            <img :src="this.detail.space.photo" alt="" />
                        </div>
                        <span class="Lname">{{this.detail.space.name}}</span>
                        <span class="Ljob" v-if="this.detail.space.tags">{{this.detail.space.tags}}</span>
                        <span class="Lblock">{{this.detail.type_name}}</span>
                    </div>
                    <span class="myBtn" @click='gobackList()' v-show="!IsPC()">Demand list</span>
                    <span class="myBtn" @click='addDetail()' :class="{'add':!IsPC()}" v-show='!addControl'>Supplementary demand</span>
                    <span class="myBtn " @click='backAddDetail()' :class="{'add':!IsPC()}"  v-show='addControl'>Return to message board</span>
                </div>
                <div class="row one_title_nano m-0" v-if="!addShow && detail">
                    <div class="row nano p-0 m-0 one_title_nano">
                        <div class="nano-content" id="home_left_lists">
                            <ul class="list-unstyled" style="padding:0 15px">
                                <li v-for='(item,index) in detail.content' :key="index"  class="myItem col-md-12">
                                    <div class="rightBox clearfix">
                                        <div class="rightimg">
                                            <img :src="item.member.thumb" alt="" />
                                        </div>
                                        <div class="rightdetail">
                                            <span class="time">{{item.addtime}}</span>
                                            <span class="Ljob" style="margin-right: 10px">{{item.member.nickname}}</span>
                                            <!--<span class="Lblock">{{detail.type_name}}</span>-->

                                            <div class="clickbord" style="margin-left:65px">
                                                {{item.content}}
                                            </div>
                                        </div>
                                        <div class="leftimg" style="width:100px">
                                        </div>
                                    </div>
                                    <div class="leftBox clearfix" v-for="replyitem in item.replies">
                                        <div class="leftimg">
                                            <img :src="detail.space.photo" alt="" />
                                        </div>
                                        <div class="leftdetail">
                                            <span class="Ljob">{{detail.space.name}}</span>
                                            <span class="Lblock"> Reply</span>
                                            <span v-if="detail.space.tags" class="Ljob">{{detail.space.tags}}</span>
                                            <span class="time">{{replyitem.created_at}}</span>
                                            <div class="clickbord">
                                                {{replyitem.content}}
                                            </div>
                                        </div>
                                        <div class="rightimg" style="width:100px;">

                                        </div>
                                    </div>
                                </li>
                                <!--<p class="text-center p-2" v-if="detail.content&&detail.content.length ==0">没有更多数据了...</p>-->
                            </ul>
                            <div v-if="detail.content&&detail.content.length ==0" class="nodata text-center">
                                <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100" alt="" />
                                <p class="text-center p-2">loading</p>

                            </div>
                        </div>
                    </div>
                </div>
                <div class="row one_title_nano m-0" v-if="addShow && detail">
                    <div class="row nano p-0 m-0 one_title_nano">
                        <div class="w-100" style="margin-top:30px;">
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-3 col-form-label col-xs-6 tc pr-0">Supplementary demand<span style="color:red">*</span></label>
                                <div class="col-md-8">
                                        <textarea class="form-control w-100" v-model="content" style="overflow:hidden">
                                        </textarea>
                                </div>
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-3 col-3 col-xs-6 col-form-label tc pr-0">Verification code</label>
                                <div class="col-md-8">
                                    <input type="text" class="myinput" v-model="captcha" />
                                    <img :src="codeUrl" id="code" @click='refresh()' class="myimg" />
                                </div>
                            </div>
                            <div class="form-group row ml-0 mr-0">
                                <label class="col-md-4 col-3 col-xs-6 col-form-label tc pr-0"></label>
                                <div class="col-md-8">
                                    <button type="submit" class="btn btn-primary" style="width: 100px;" @click="addParentContent()">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import toast from './toast/Toast'
    export default ({
        name: 'feedback',
        data() {
            return {
                codeUrl:"/api/pc/captcha/"+Date.parse(new Date()),
                homeLists: [],
                type:[],
                detail : {},
                loadShow: false,
                page: 1,
                page_size : 10,
                total_page: 1,
                curIndex: null,
                viewToggle: true,
                clickToggle: false,
                detailShow: false,
                addShow:false,
                addControl:false,
                selectType : null,
                content : '',
                captcha : ''
            }
        },
        components: {
            toast
        },
        mounted() {
            document.getElementById('home_left_list').addEventListener('scroll', this.Scrolles);
//            document.getElementById('home_left_lists').addEventListener('scroll', this.Scrolless);
            this.load()
        },
        created() {
            this.viewToggle = this.IsPC();
            this.getList();
            this.getType();
        },
        methods: {
            refresh(){
                $("#code").attr("src","https://www.imsilkroad.com/api/pc/captcha/"+ Date.parse(new Date()));
            },
            gotodetai(num) {   //需求详情
                var self = this;
                this.$axios.post('/api/pc/consultdetail', {id:num}).then(data => {
                    if (data.data.state) {
                        self.detail=data.data.data;
                        this.curIndex = num;
                        this.clickToggle = false;
                        this.detailShow = true;
                    }
                })

            },
            gobackAdd() {  //添加需求
                this.clickToggle = false;
                this.detailShow = false;
            },
            addDetail(){
              this.addShow=true;
              this.addControl=true;
            },
            backAddDetail(){
              this.addShow=false;
              this.addControl=false;
            },
            gobackList() {   //需求列表
                this.clickToggle = true;
                this.detailShow = false;
            },
            gobacks() {
                this.detailShow = false;
            },
            Scrolles() {
                let that = this;
                var top = document.getElementById('home_left_list').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_left_list').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_left_list').scrollHeight; // 总高度
                if ((all - 20) < (top + client)) {
                    that.page++;
                    if (that.page > that.total_page) {
                        return;
                    }
                    this.$axios.post('/api/pc/myconsultlist', {page:that.page, page_size: that.page_size}).then(data => {
                        if (data.data.state) {
                            var homeListes = data.data.data.data;
                            JSON.stringify(homeListes);
                            var new_homeLists = that.homeLists.concat(homeListes);
                            that.homeLists = new_homeLists;
                        }
                    })
                }
            },
            Scrolless() {
                let that = this;
                var top = document.getElementById('home_left_lists').scrollTop; // 滚动条到上面的距离
                var client = document.getElementById('home_left_lists').clientHeight; // 可视区域的高度
                var all = document.getElementById('home_left_lists').scrollHeight; // 总高度
                if ((all - 20) < (top + client)) {
                    this.pages++;
                    if (this.pages > this.total_pages) {

                    }
//
                }
            },
            getType() {
                var self = this;
                this.$axios.post('/api/pc/consultlist').then(data => {
                    if (data.data.state) {
                        self.type=data.data.data;
                    }
                })
            },
            getList(){
                var self = this;
                this.$axios.post('/api/pc/myconsultlist', {page:self.page, page_size: self.page_size}).then(data => {
                    if (data.data.state) {
                        self.homeLists=data.data.data.data;
                        self.total_page=Math.ceil(data.data.data.total/self.page_size);
                    }
                })
            },
            addContent(){

                if (!this.selectType) {
                    $(".wrap").text('Type cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                }

                if (!this.content || this.content.length == 0) {
                    $(".wrap").text('Specific needs should not be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                }

                if (!this.captcha || this.captcha.length != 4) {
                    $(".wrap").text('Verification code cannot be empty！');
                    $(".wrap").show().delay(1500).hide(100);
                }
                var param = {
                    typeid:this.selectType,
                    content: this.content,
                    captcha: this.captcha
                }
                this.$axios.post('/api/pc/memberconsult', param).then(data => {
                    if (data.data.state) {
                        this.getList();
                        this.content = '';
                        this.captcha = '';
                    } else {
                        $(".wrap").text(data.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }
                })
            },
            addParentContent(){
                var param = {
                    typeid:this.detail.typeid,
                    content: this.content,
                    captcha: this.captcha,
                    parent_id : this.curIndex
                }
                this.$axios.post('/api/pc/memberconsult', param).then(data => {
                    if (data.data.state) {
                        this.content = '';
                        this.captcha = '';
//                        this.getList();
                        $(".wrap").text('Released successfully！');
                        $(".wrap").show().delay(1500).hide(100);
                    } else {
                        $(".wrap").text(data.data.error);
                        $(".wrap").show().delay(1500).hide(100);
                    }
                })
            }
        }
    })
</script>
<style scoped type="">
    .mytitle {
        height: 65px;
        font-size: 18px;
        font-family: PingFangSC-Medium;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 65px;
    }

    .lItem {
        padding: 15px 0;
        border-bottom: 1px solid #EBEBEB;
    }

    .lItem:hover {
        cursor: pointer;
    }
    .myinput{
        width:70px;
        height:34px;
        background:rgba(255,255,255,1);
        border-radius:4px;
        border:1px solid rgba(193,193,193,1);
    }
    .myimg{
        width:52px;
        height:24px;
    }
    .lItem.cur .Ldes {
        color: #4585F5;
    }

    .Lblock {
        padding: 2px 15px;
        height: 20px;
        background: rgba(69, 133, 245, .2);
        font-size: 10px;
        font-family: PingFangSC-Medium;
        font-weight: 500;
        color: rgba(69, 133, 245, 1);
        line-height: 16px;
    }

    .Ldes {
        max-height: 49px;
        overflow: hidden;
        font-size: 15px;
        font-family: PingFangSC-Medium;
        font-weight: 600;
        color: rgba(51, 51, 51, 1);
        line-height: 23px;
        margin-top: 10px !important;
        margin-bottom: 15px !important;
    }

    .itemBottom {
        display: flex;
        justify-content: space-between;
    }

    .imgdiv {
        width: 25px;
        height: 25px;
        display: inline-block;
        border-radius: 50%;
        overflow: hidden;
        vertical-align: bottom;
        border: 1px solid transparent;
    }
    .imgdiv img{
        width: 25px;
        height: 25px;
        border-radius: 50%;
    }
    .imgdiv.add{
        display: inline;
    }
    .Ldetail img {
        width: 25px;
        height: 25px;
    }

    .Lname {
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(84, 87, 102, 1);
        line-height: 17px;
    }

    .Ljob {
        width: 100px;
        overflow: hidden;
        height: 20px;
        font-size: 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
    }

    .clearfix .time {
        width: 130px;
        overflow: hidden;
        height: 20px;
        font-size: 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: #9092A6;
        line-height: 20px;
    }

    .itemBottom .time {
        height: 17px;
        font-size: 12px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(144, 146, 166, 1);
        line-height: 30px;
    }

    .ellipse {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }

    .myBtn.add {
        right: 100px;
    }

    .myBtn {
        height: 30px;
        display: block;
        position: absolute;
        top: 20px;
        right: 20px;
        font-size: 12px;
        padding: 2px 10px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: rgba(133, 144, 166, 1);
        line-height: 28px;
        text-align: center;
        background: rgba(242, 243, 244, 1);
        border-radius: 20px;
    }

    .myBtn:hover {
        cursor: pointer;
    }

    .two_ell {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .nano-content {
        padding-left: 0;

    }
    .leftBox{
        display: flex;
        justify-content: space-between;
        flex-direction: row;
        margin-bottom: 30px;
    }
    .rightBox{
        display: flex;
        justify-content: space-between;
        flex-direction: row-reverse;
        margin-bottom: 30px;
    }
    .leftimg{
        width:40px;
        height:40px;

    }
    .rightimg{
        width:40px;
        height:40px;
    }
    .rightimg img,.leftimg img{
        width:40px;
        height:40px;
        border-radius: 50%;
    }
    .leftdetail{
        margin-left:25px;
        width: calc(100% - 60px);
    }
    .rightdetail{
        margin-right:25px;
        width: calc(100% - 60px);
    }
    .rightdetail span{
        float: right;

    }
    .replayCont{
        display:flex;
        justify-content: space-between;
        padding:5px 15px;
        width:100%;
        background:rgba(242,243,244,1);
        margin-top: 20px;
    }
    .replayTime{
        height:20px;
        font-size:13px;
        font-weight:400;
        color:rgba(144,146,166,1);
        line-height:20px;
    }
    .replayicon{
        height:20px;
        font-size:14px;
        font-weight:500;
        color:rgba(69,133,245,1);
        line-height:20px;
    }
    .add{
        right: 80px;
    }
    .myItem{
        margin-top:30px;
    }
    .rightBox .clickbord{
        margint-top:30px;
        float:right;
    }
    .clickbord{
        padding:15px 20px;
        margin-top:10px;
        clear:both;
        border-radius: 10px;
        background:rgba(247,247,247,1);
        font-size:14px;
        font-family:PingFangSC-Regular;
        font-weight:400;
        color:rgba(128,128,128,1);
        line-height:21px;
        width: fit-content;
    }
    @media screen and (min-width: 500px) {
        .need {
            margin-top:-210px
        }
    }
    @media screen and (max-width: 500px) {
        .addneed {
            padding-bottom:50px!important
        }
    }
</style>
